<template>
    <div>
    <!--Content Wrap Start-->
    <div class="kode_content" style="padding-top:5%">
    
    	<!--Welcome to Democracy Wrap Start-->
        <section class="kode_about_welcome" >
            <div class="container">
            	<div class="row" >
                    <div class="col-md-5">
                        <div class="kode_welcome">
                            <figure>
                                <img :src="file_path+foto" alt="Image Here">
                            </figure>
                        </div>
                    </div>
                
                    <div class="col-md-7">
                        <div class="kode_wel_demo_des">
                            <h6>Misi Dukcapil</h6>
                            <h4>Misi</h4>
                            <p v-html="isi"></p>
                            <!-- <a class="kode_link_3" href="#">See More <i class="fa fa-angle-right"></i></a> -->
                        </div>
                    </div>
                    
            	</div>
            </div>
        </section>
        <!--Welcome to Democracy Wrap Start-->
 
        
    </div>
    <!--Content Wrap End-->        
    </div>
</template>


<script>

const ADD_URL = URL_APP + "api/v1/publish_misi1/";
const FILE_LOAD = URL_APP + "uploads/";

    export default {
        data(){
            return{
                file_path: FILE_LOAD,
                list_data : [],
        		foto : '',
        		isi : '',
            }
        },

        methods: {
            getOne: function() {
            fetch(ADD_URL + "getOne", {
                method: "get",
                headers: {
                "content-type": "application/json",
                },

            })
                .then(res => res.json())
                .then(res_data => {
                //   this.list_data = res_data.data;
                //   this.page_last = res_data.jml_data;
                    // console.log(res_data);

                var misi1 = res_data[0];
                
                // this.id_misi1 = misi1.id;
                // this.createAt = misi1.createAt;

                    // this.createBy = misi1.createBy;
                    // this.deskripsi = misi1.deskripsi;
                    this.foto = misi1.foto;    
                    this.isi = misi1.isi;
                    // this.judul = misi1.judul;
                    // this.sumber = misi1.sumber;



                });
            },

            




        },

        mounted() {
            this.getOne();
        }
    }
</script>
 